import React from 'react';
import { FaArrowLeftLong } from 'react-icons/fa6';
import UseCreateUserAddressPage from './UseCreateUserAddressPage';
import Navigation from '../../../layout/Navigation/Navigation';
import { stat } from 'fs';

const CreateUserAddressPage: React.FC = () => {
  const { handleSubmit, handleChange, states, navigate } = UseCreateUserAddressPage();

  return (
    <div className='flex items-center justify-center bg-white px-5 sm:px-5 md:px-6 lg:px-6 py-3 sm:py-3 md:py-12 lg:py-12'>
      <div className='flex flex-col lg:flex-row bg-white w-full max-w-7xl rounded-xl sm:rounded-xl md:rounded-xl xl:rounded-xl overflow-hidden pb-6 sm:pb-6 md:pb-0 lg:pb-0'>
        {/* Global Navigation */}
        <Navigation />
        {/* Mobile(Sm MD) veiw */}
        <div className='block sm:block md:hidden lg:hidden'>
          <div className='px-2   text-lg font-semibold flex items-center font-poppins'>
            <FaArrowLeftLong onClick={() => navigate(-1)} className='mr-3' />
            {states.pageTitle.current}
          </div>
        </div>
        <div className='flex-1 bg-white rounded-xl  ml-0 lg:ml-6 mt-4 sm:mt-4 md:mt-0 lg:mt-0 border'>
          <div className='hidden sm:hidden md:block lg:block justify-between items-center py-3 px-6 border-b'>
            <h1 className='text-xl text-[#1A1A1A] font-medium font-poppins'> {states.pageTitle.current}</h1>
          </div>
          <form onSubmit={handleSubmit} className='py-4 px-4 sm:px-4 md:px-6 lg:px-6'>
            <>
              {/* <div className="mb-3 sm:mb-3 md:mb-4 lg:mb-4">
                                <label className="block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins text-[#1A1A1A]">
                                    Shop Name
                                    <span className="text-red-600 font-poppins">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="shopName"
                                    placeholder="Enter shop name"
                                    className="w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl font-poppins text-sm sm:text-sm md:text-base lg:text-base"
                                    value={states.formData.shopName}
                                    onChange={handleChange}
                                />
                                {states.errors.shopName && (
                                    <p className="text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins">
                                        {" "}
                                        {states.errors.shopName}
                                    </p>
                                )}
                            </div> */}
              <div className='mb-3 sm:mb-3 md:mb-4 lg:mb-4'>
                <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                  Address Line-1
                  <span className='text-red-600 font-poppins'>*</span>
                </label>
                <input
                  type='text'
                  name='address1'
                  placeholder='Enter address'
                  value={states.formData.address1}
                  onChange={handleChange}
                  className='font-poppins w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                />
                {states.errors.address1 && (
                  <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                    {states.errors.address1}
                  </p>
                )}
              </div>
              <div className='mb-3 sm:mb-3 md:mb-4 lg:mb-4'>
                <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                  Address Line-2
                  <span className='text-red-600 font-poppins'>*</span>
                </label>
                <input
                  type='text'
                  name='address2'
                  placeholder='Enter address'
                  value={states.formData.address2}
                  onChange={handleChange}
                  className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                />
                {states.errors.address2 && (
                  <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                    {states.errors.address2}
                  </p>
                )}
              </div>

              <div className='mb-3 sm:mb-3 md:mb-4 lg:mb-4'>
                <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins' htmlFor='city'>
                  City <span className='text-red-600 font-poppins'>*</span>
                </label>
                <input
                  type='text'
                  name='city'
                  placeholder='Enter city'
                  value={states.formData.city}
                  onChange={handleChange}
                  className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                />
                {states.errors.city && (
                  <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                    {states.errors.city}{' '}
                  </p>
                )}
              </div>
              <div className='grid grid-cols-2 gap-4 md:grid-cols-3 mb-3 sm:mb-3 md:mb-4 lg:mb-4'>
                <div className='col-span-1'>
                  <label
                    className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                    htmlFor='city'
                  >
                    State<span className='text-red-600 font-poppins'>*</span>
                  </label>
                  <select
                    name='state'
                    value={states.formData.state}
                    onChange={handleChange}
                    className='w-full bg-white border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                  >
                    <option value='' disabled className='font-poppins'>
                      Select state
                    </option>
                    {states.stateList &&
                      states.stateList.map(state => (
                        <option className='font-poppins' key={state} value={state}>
                          {state}
                        </option>
                      ))}
                  </select>
                  {states.errors.state && (
                    <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                      {states.errors.state}
                    </p>
                  )}
                </div>

                <div className='col-span-1'>
                  <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                    Pincode
                    <span className='text-red-600 font-poppins'>*</span>
                  </label>
                  <input
                    type='text'
                    name='pincode'
                    placeholder='Enter pincode'
                    value={states.formData.pincode}
                    onChange={handleChange}
                    className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                  />
                  {states.errors.pincode && (
                    <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                      {states.errors.pincode}
                    </p>
                  )}

                  {states.wrongPincodeError && (
                    <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                      {'Enter a valid pincode for your city'}
                    </p>
                  )}
                </div>

                <div className='col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1 '>
                  <label
                    className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                    htmlFor='city'
                  >
                    Country <span className='text-red-600 font-poppins'>*</span>
                  </label>
                  <select
                    name='country'
                    value={states.formData.country}
                    onChange={handleChange}
                    className='w-full bg-white border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                  >
                    {states.countryList &&
                      states.countryList.map(country => (
                        <option
                          className='text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                          key={country.name}
                          value={country.name}
                        >
                          {country.name}
                        </option>
                      ))}
                  </select>
                  {states.errors.country && (
                    <p className='text-red-500 text-xs sm:text-xs md:text-sm lg:text-sm font-poppins'>
                      {states.errors.country}
                    </p>
                  )}
                </div>
              </div>

              {states.addressId && states.addressId !== '' && (
                <div className='grid grid-cols-2 sm:grid-cols-2 gap-4 md:grid-cols-2 mb-3 sm:mb-3 md:mb-4 lg:mb-4'>
                  {/* <div className='col-span-1  '>
                  <div className='flex items-center'>
                    <input
                      type='checkbox'
                      id='billingAddress'
                      name='billingAddress'
                      checked={states.formData.billingAddress === 1}
                      onChange={handleChange}
                      className='mr-2 sm:mr-2 md:mr-3 lg:mr-4 min-h-5 min-w-6 sm:min-h-5 sm:min-w-6 md:min-h-6 md:min-w-7 lg:min-h-6 lg:min-w-7'
                    />
                    <label
                      htmlFor='billingAddress'
                      className='mb-1 font-poppins text-sm sm:text-sm md:text-base lg:text-base'
                    >
                      Billing Address?
                    </label>
                  </div>
                </div> */}

                  <div className='col-span-1 -ml-2 sm:-ml-2 md:ml-0 lg:ml-0'>
                    <div className='flex items-center  '>
                      <input
                        type='checkbox'
                        id='shippingAddress'
                        name='shippingAddress'
                        checked={states.formData.shippingAddress === 1}
                        onChange={handleChange}
                        className='mr-2 sm:mr-2 md:mr-3 lg:mr-4 min-h-5 min-w-6 sm:min-h-5 sm:min-w-6 md:min-h-6 md:min-w-7 lg:min-h-6 lg:min-w-7'
                      />
                      <label
                        htmlFor='shippingAddress'
                        className='mb-1 font-poppins text-sm sm:text-sm md:text-base lg:text-base'
                      >
                        Shipping Address?
                      </label>
                    </div>
                  </div>
                </div>
              )}
              <div className='text-start py-0 sm:py-0 md:py-2 lg:py-2'>
                <button
                  type='submit'
                  className='min-w-full sm:min-w-full md:min-w-full lg:min-w-[25rem] px-8 py-3 bg-red-700 text-white rounded-xl hover:bg-red-700 transition font-semibold font-poppins'
                >
                  Submit
                </button>
              </div>
            </>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateUserAddressPage;
